import React from "react";

export default function Spinner() {
  return (
    <span className="spinner" aria-hidden>
      <svg viewBox="0 0 24 24">
        <circle className="ring" cx="12" cy="12" r="9" />
        <circle className="seg" cx="12" cy="12" r="9" />
      </svg>
    </span>
  );
}
